import axios from '../api/axios';
import { baseURL } from '../config/url';

const profileUrl = baseURL + '/users';

const getProfile = async () => {
  return axios.get(`${profileUrl}/profile/me`);
};

const updateProfile = async (payload) => {
  return axios.patch(`${profileUrl}/profile/me`, payload);
};

const getUser = async (id) => {
  return axios.get(`${profileUrl}/${id}`);
};

const updateUser = async (id, payload) => {
  return axios.patch(`${profileUrl}/${id}`, payload);
};

const getTeachers = async (includeInactive = false) => {
  const query = includeInactive ? '?includeInactive=true' : '';
  return axios.get(`${profileUrl}/teachers${query}`);
};

const getAdvisors = async (includeInactive = false) => {
  const query = includeInactive ? '?includeInactive=true' : '';
  return axios.get(`${profileUrl}/advisors${query}`);
};

export default {
  getProfile,
  updateProfile,
  getUser,
  updateUser,
  getTeachers,
  getAdvisors,
};
